module.exports = __webpack_public_path__ + "img/6629fd0.png";